import { _size, _split } from 'libs/lodash';

export const isCsvEmpty = (csv: string): boolean => {
  /* Only one header line in csv means it's empty */
  return _size(_split(csv, /\r\n|\r|\n/)) <= 1;
};
